"use client";

import { ChooseUsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedChooseUsSection from "../Components/GeneratedChooseUsSection";

const ChooseUs: FC<ChooseUsSectionProps> = (props) => {
  return <GeneratedChooseUsSection {...props} />;
};

export default ChooseUs;
